import { TimelineMax } from 'gsap'
// import 'ScrollToPlugin'
import Helper from '../../helpers/helper'
import { EventBus } from '@/event-bus'

export function animations ($scrollmagic) {
  const container = document.getElementById('animation-container')
  const containerWidth = Helper.elementWidth(container)
  const containerMedium = Helper.elementMedium(container)
  const line1 = document.getElementById('line1')
  const line2 = document.getElementById('line2')
  const line2r = document.getElementById('line2repeat')
  const line3 = document.getElementById('line3')
  const line3r = document.getElementById('line3repeat')
  const line1Width = line1.getBoundingClientRect().width
  const line2Width = line2.getBoundingClientRect().width
  const line3Width = line3.getBoundingClientRect().width
  const fullLineWidth = line1Width + line2Width + line3Width
  const line1LeftPosition = ((containerWidth - fullLineWidth) / 2)
  const line2LeftPosition = line1LeftPosition + line1Width
  const line3LeftPosition = line2LeftPosition + line2Width - 1 // 1 ARREGLO
  const circle1 = document.getElementById('circle1')
  const circle2 = document.getElementById('circle2')
  const circle3 = document.getElementById('circle3')
  const circle3r = document.getElementById('circle3repeat')
  const circle4 = document.getElementById('circle4')
  const circlePartWidth = circle1.getBoundingClientRect().width
  const circlePartHeight = circle1.getBoundingClientRect().height
  const circle1LeftPosition = containerMedium - circlePartWidth
  const circle2LeftPosition = circle1LeftPosition + circlePartWidth - 1
  const circle4LeftPosition = circle1LeftPosition
  const circle3LeftPosition = circle4LeftPosition + circlePartWidth - 1
  const circleTopPosition = Helper.circleTopPosition()
  const circleBottomPartTopPosition = circlePartHeight + circleTopPosition - 1 // top position mas abajo fijada

  var tl = new TimelineMax()
  tl.to(line1, 1, {
    top: '650px',
    left: line1LeftPosition
  }, 0)
  tl.to(line2, 1, {
    top: '650px',
    left: line2LeftPosition
  }, 0)
  tl.to(line2r, 1, {
    top: '15%',
    left: '80%'
  }, 0)
  tl.to(line3, 1, {
    top: '650px',
    left: line3LeftPosition
  }, 0)
  tl.to(line3r, 1, {
    top: '300px',
    left: '45%'
  }, 0)
  tl.to(circle1, 1, {
    top: circleTopPosition,
    left: circle1LeftPosition
  }, 0)
  tl.to(circle2, 1, {
    top: circleTopPosition,
    left: circle2LeftPosition
  }, 0)
  tl.to(circle3, 1, {
    top: circleBottomPartTopPosition,
    left: circle3LeftPosition
  }, 0)
  tl.to(circle3r, 1, {
    top: '100px',
    left: '10%'
  }, 0)
  tl.to(circle4, 1, {
    top: circleBottomPartTopPosition,
    left: circle4LeftPosition
  }, 0)
  // tl.addCallback(function () { EventBus.$emit('showCompleteLogo') })
  const logoAnimation = $scrollmagic.scene({
    triggerElement: container,
    offset: '500px',
    triggerHook: 'onEnter',
    duration: '100%'
  })
    // .addIndicators()
    .setTween(tl)
    .on('progress', (event) => {
      if (event.progress < 0.9) { EventBus.$emit('showParts') } else { EventBus.$emit('showCompleteLogo') }
    })
  $scrollmagic.addScene(logoAnimation)
}
